import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextmagicRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#1D4ED8",
		fillRule: "evenodd",
		d: "M25.8 4.1H4v14.3h2.7v8.1l6.9-8.1h12zM13.7 18.4l9.7-11.6H6.8v11.6z",
		clipRule: "evenodd"
	})
});
export default SvgTextmagicRegularIcon;
